import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const womensShelterFinancesDataForm: Form<Client> = {
  key: 'womensShelterFinances',
  title: 'FH Finanzen',
  fields: [
    {
      key: 'credit',
      label: 'Darlehen',
      fieldTypes: 'headline',
    },
    {
      key: 'financesDeposit',
      label: 'Kaution',
      fieldTypes: 'number',
    },
    {
      key: 'financesDate',
      label: 'Datum',
      fieldTypes: 'date',
    },
    {
      key: 'rentPerDay',
      label: 'Miete pro Tag',
      fieldTypes: 'headline',
    },
    {
      key: 'financesColdRent',
      label: 'Kaltmiete',
      fieldTypes: 'number',
    },
    {
      key: 'financesColdRent',
      label: 'Kaltmiete',
      fieldTypes: 'number',
    },
    {
      key: 'financesExtras',
      label: 'Nebenkosten',
      fieldTypes: 'number',
    },
    {
      key: 'financesMonthsRent',
      label: 'Monatsmiete',
      fieldTypes: 'number',
    },
  ],
};

export default womensShelterFinancesDataForm;
